import { useState, useEffect } from "react";
import EditSaleUI from "../components/UpdateSaleUI";
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function EditSale({ selectedSale, allProducts, productTypes, onUpdate, onClose }) {
  const [sale, setSale] = useState(selectedSale);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    const fetchSale = async (saleId) => {
      const user = getUser();
      try {
        const res = await fetch(`${URL}/api/sales/${saleId}`, {
          headers: {
            "X-Empresa-Id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener la venta");
        const data = await res.json();
  
        setSale(data);
  
        setSelectedProducts(
          data.products.reduce((acc, product) => {
            const fullProduct = allProducts.find(p => p.id === product.product_id);
            const isDecimal = fullProduct?.sell_method === "Decimal";
            acc[product.product_id] = {
              product_id: product.product_id,
              quantity: product.quantity,
              isDecimal,
            };
            return acc;
          }, {})
        );
  
        setPaymentMethods(
          (data.payments || []).map(p => ({
            ...p,
            isBonus: p.adjustment < 0,
            adjustment: Math.abs(p.adjustment)
          }))
        );
        setDiscount(data.discount || 0);
  
      } catch (error) {
        console.error(error);
      }
    };
  
    if (selectedSale && selectedSale.id) {
      fetchSale(selectedSale.id);
    } else {
      setSale(null);
      setSelectedProducts({});
      setPaymentMethods([]);
      setDiscount(0);
    }
  }, [selectedSale, allProducts]);

  const handleProductChange = (productId, quantity) => {
    setSelectedProducts((prev) => ({
      ...prev,
      [productId]: {
        product_id: parseInt(productId),
        quantity: parseInt(quantity, 10),
      }
    }));
  };

  const handleSubmit = () => {
    const productsArray = Object.values(selectedProducts).filter(p => p.quantity > 0);

    if (productsArray.length === 0 || !paymentMethods.length === 0) {
      return;
    }

    const user = getUser()
    fetch(`${URL}/api/sales/${sale.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Empresa-Id": user?.empresa_id,
      },
      body: JSON.stringify({
        products: productsArray,
        payments: paymentMethods,
        discount,
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al actualizar la venta");
        return res.json();
      })
      .then(() => {
        onUpdate()
        onClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <EditSaleUI
      sale={sale}
      productTypes={productTypes}
      allProducts={allProducts}
      selectedProducts={selectedProducts}
      selectedType={selectedType}
      setSelectedType={setSelectedType}
      paymentMethods={paymentMethods}
      setPaymentMethods={setPaymentMethods}
      discount={discount}
      setDiscount={setDiscount}
      handleProductChange={handleProductChange}
      handleSubmit={handleSubmit}
    />  
  );
}